var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.layout)?_c('Head'):_vm._e(),_c('transition',{attrs:{"name":"header-transition","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[_c('router-view')],1),(_vm.layout && _vm.layoutFoot)?_c('Foot'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }